import * as L from 'leaflet';
import { faExpand } from '@fortawesome/pro-regular-svg-icons';
import { createBasicLeafletIconButton, toggleActiveClass } from './helpers';

export class ControlFullscreen extends L.Control {
  onAdd(map: L.Map) {
    const anchorElement = createBasicLeafletIconButton(faExpand);

    anchorElement.onclick = () => {
      if(document.fullscreenElement == null) {
        map.getContainer().requestFullscreen().then(() => {
          toggleActiveClass(anchorElement);
        });
      } else {
        document.exitFullscreen().then(() => {
          toggleActiveClass(anchorElement);
        });
      }

      map.invalidateSize();
    }

    return anchorElement;
  }
}
